import * as React from 'react';

function PhotoUploadBaloonPrizeContest({ handleClick, ...props }) {
    return (
        <svg
            width="100%"
            viewBox="0 0 702 315"
            fill="none"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M125.641 10.866c7.192-.508 15.366-1.17 24.189-1.883l28.67-.215c5.532.138 10.027.25 13.127.25 10.656 0 27.241.51 39.431.884 5.826.18 10.648.327 13.339.374 14.602.255 22.873-.24 28.199-1.078L353.161 3.7c2.357-.355 5.371-.759 8.844-1.08C365.427 2.3 369.953 2 375.234 2c65.768 0 119.083 31.786 119.083 109.998 0 22.482-5.113 33.111-15.266 48.747-9.253 18.49 43.949 22.918 43.949 22.918s-9.715 25.886-62.454 18.028C453.607 206.738 443.429 273 403.181 273c-18.086 0-91.255-9.036-101.315-8.164l-34.88-1.387-3.058-.169-62.913 1.556c-22.515 0-43.015-1.556-60.914-3.611-13.4-1.538-51.497-1.225-60.933-1.031.73.039 1.468.066 2.212.082-5.318.036-5.381-.016-2.212-.082C15.29 256.848.6 169.209 2.12 109.162c0-25.15-3.734-70.45 30.5-89.403 27.387-15.161 62.322-7.623 93.021-8.893z"
                fill="#FFEACC"
                stroke="#FBA919"
                strokeWidth={3}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <text
                fill="#000"
                style={{
                    whiteSpace: 'pre'
                }}
                fontFamily="Roboto"
                fontSize={16}
                letterSpacing=".02em"
            >
                <tspan x={66} y={143.469}>
                    {'\u010Ce je v tvojem osebnem arhivu kak\u0161na fotografija '}
                </tspan>
                <tspan x={66} y={165.469}>
                    {'te izletni\u0161ke ideje jo lahko nalo\u017Ei\u0161 in s tem '}
                </tspan>
                <tspan x={66} y={187.469}>
                    {'sodeluje\u0161 v izboru za glavno nagrado '}
                </tspan>
                <tspan x={262.92} y={209.469}>
                    .
                </tspan>
            </text>
            <text
                fill="#000"
                style={{
                    whiteSpace: 'pre'
                }}
                fontFamily="Roboto"
                fontSize={16}
                fontWeight="bold"
                letterSpacing=".02em"
            >
                <tspan x={344.043} y={187.469}>
                    Nikon Z 30
                </tspan>
                <tspan x={66.692} y={209.469}>
                    in 15 majic Kam za vikend
                </tspan>
            </text>
            <path
                d="M610.301 143.39c-5.596.425-10.043 3.246-8.924 4.642 1.119 1.395 4.507-.789 8.924-1.244 5.596-.607 10.345.637 9.922-1.183-.333-1.275-3.328-2.731-9.922-2.215zM584.649 140.993c-2.813-.546-3.962 2.912-4.597 6.735-.545 3.246 2.026 5.036 3.962 3.884 1.906-1.123 2.36-3.065 2.602-5.583.363-3.186-.031-4.672-1.967-5.036zM648.384 157.164c-1.391.94-3.781 6.129-4.537 11.347-.756 5.218-1.452 10.285-.151 10.467 2.752.395.726-3.58.847-6.675.212-5.643 5.172-6.158 7.078-9.101 3.176-4.855-.968-7.555-3.237-6.038zM609.877 148.942c-2.934-.425-5.444.789-4.96 1.79s2.389.061 4.718.334c2.935.333 5.324 1.699 5.234.485-.061-.819-1.513-2.124-4.992-2.609zM616.321 137.11c.605.03 1.331.03 2.692.091 2.36.06-7.985-3.156-11.464-3.216-6.927-.122-10.164 3.094-7.532 6.583 1.966 2.64 3.388-3.914 16.304-3.458zM604.856 90.902c11.434.82 23.443 5.855 29.463 7.494 3.055.819 6.474 1.942 9.105 2.852a83.03 83.03 0 01-1.785-3.671c-4.628-10.012-.604-21.541 1.815-30.643 2.42-9.102 6.202-28.823-1.27-32.676-16.516-8.465-40.806 23.786-53.814 40.473-6.11 7.858-9.256 13.926-12.311 19.478 7.229-1.456 20.751-3.883 28.797-3.307z"
                fill="#414142"
            />
            <path
                d="M696.421 141.691c-2.148-6.068-11.404-7.828-15.457-8.283-15.065-4.703-25.017-12.348-32.64-23.726-3.569-.728-7.532-1.699-10.012-2.791-5.445-2.336-23.171-8.526-30.31-9.557-7.139-1.032-17.424-1.456-29.16 1.82-2.511.698-4.78 1.335-6.867 1.912-2.481 3.701-5.536 7.403-10.194 11.499-.908.788-2.813 2.154-5.082 3.64-3.751 1.275-7.895 1.366-10.981 1.426-1.724.031-3.115.061-4.204.304-5.112 1.062-12.13 3.185-14.096 9.375-1.331 4.217-.273 9.253.847 12.773 1.27 3.913 3.176 7.736 5.021 9.981 6.534 8.01 16.304 10.71 24.986 12.288 4.779.88 8.47 1.214 11.041 1.365-.938 2.518-2.117 4.946-3.69 7.1-3.146 4.399-7.139 8.495-10.497 11.893l-.363.364-.333.334c-5.172 5.339-9.014 11.286-10.315 15.443-3.962 12.712.635 20.418 7.169 25.424 10.83 8.313 24.956 18.477 57.565 4.612 19.178-8.131 26.347-23.726 29.13-37.045a7.61 7.61 0 003.66 1.517c.757.091 1.483.152 2.178.152 4.326 0 7.653-2.003 9.952-5.947 1.604-2.761.878-5.643.273-8.161-.424-1.669-.847-3.398-.787-5.34.363-.637 1.936-1.881 2.995-2.7 1.18-.941 2.541-1.972 3.72-3.186.121-.121.242-.273.363-.394.908.182 1.846.242 2.783.242 6.867 0 14.883-3.944 19.451-6.553 4.083-2.366 17.091-10.649 13.854-19.781zm-136.909 13.865c-7.441-1.365-15.76-3.58-20.902-9.891-2.42-2.973-6.05-11.893-4.659-16.292.636-2.033 3.661-3.641 8.954-4.733.484-.091 1.785-.122 2.965-.152 2.359-.061 5.414-.121 8.621-.667 1.059 0 2.208.03 3.448.091 7.442.242 13.582.06 18.785-.365-4.961 2.549-13.249 1.396-13.249 1.396s.907 2.124 2.904 4.369c-4.991-.152-9.226-1.669-12.856-2.913 2.964 7.494 6.715 8.556 7.925 8.678-10.164-.365-19.934-11.53-19.692-9.982 2.359 15.989 12.13 18.962 18.603 19.599 3.055.304 7.502-.576 11.767-2.245.151 3.671.061 8.95-.968 14.442-2.117-.061-6.019-.304-11.646-1.335zm31.46 35.073c-.273.879-.938 2.821-1.936 4.672 0 .03-.031.03-.031.06-.06.122-.151.274-.211.395 0 .03-.031.061-.031.061-.665 1.152-1.452 2.275-2.359 3.003-.091.091-.182.152-.303.243-1.966 2.063-4.96 4.247-10.526 5.309-4.024.759-6.685.759-9.741-1.456a14.46 14.46 0 01-3.599-3.792c-.061-.091 0-.213.121-.213 4.537-.242 9.286-4.005 11.706-6.25.061-.06.151-.06.182 0 1.573 1.699 3.569 2.64 5.777 3.034h.031c4.688.061 9.347-3.974 10.678-5.249.121-.06.302.031.242.183zm35.512 4.55c-7.683 10.771-14.066 8.647-17.665 6.159-3.812-2.669 2.359-11.498-8.591-17.445-4.87-2.639-9.256-2.579-15.276-1.335-6.897 1.426-9.589 3.338-11.525 2.943-1.906-.394-2.904-2.579-6.201-4.49-.242-.122-.454-.243-.696-.364a72.711 72.711 0 004.658-5.825 29.941 29.941 0 001.573-2.428c.303 1.912 1.089 3.641 2.148 4.794 2.541 2.761 5.657 2.609 7.925 2.488.878-.03 1.725-.091 2.299.061.666.151 1.18.303 1.604.424 1.028.304 1.815.516 2.904.516.544 0 1.149-.061 1.905-.182 1.785-.273 3.812-1.638 5.445-3.61 1.785-2.124 2.662-4.521 2.39-6.523-.272-2.124-1.301-3.763-2.934-4.612-1.543-.819-3.479-.789-5.173.061-1.059.546-1.482 1.85-.938 2.882.545 1.062 1.846 1.487 2.874.94.454-.242.908-.273 1.24-.091.484.243.635.941.666 1.335.09.789-.454 2.063-1.452 3.216-1.029 1.244-2.239 2.003-2.844 2.124-1.421.213-1.754.122-2.934-.212a24.981 24.981 0 00-1.845-.486c-1.18-.273-2.329-.212-3.479-.151-2.087.091-3.448.121-4.567-1.123-.908-.971-1.604-3.55-.726-5.522.302-.667 1.028-1.092 2.51-1.941 1.815-1.032 4.326-2.428 7.23-5.401 5.687-5.825 6.655-19.175 6.715-19.751.091-1.183-.816-2.215-1.996-2.306-1.18-.091-2.208.819-2.299 2.003-.242 3.428-1.694 13.137-5.475 17.02-2.481 2.549-4.568 3.702-6.262 4.672-.423.243-.847.455-1.24.698 3.025-9.8 2.692-19.963 2.299-24.605.423-.364.817-.728 1.24-1.062.242-.182.514-.395.756-.607 12.009-9.466 21.266-6.614 27.043-8.586 5.687-1.972 10.225-5.219 12.675-7.676.06.061.151.091.211.152.817 3.731 4.175 13.501 10.255 18.992.605.546-2.995-7.706-3.842-12.924 2.451 2.791 4.78 5.612 7.563 7.372-.545 5.552-1.452 18.204-1.331 22.846.272 7.555.847 26.79-6.837 37.56zm28.647-31.887c-.878.911-1.997 1.76-3.086 2.61-2.692 2.123-5.475 4.278-5.626 7.645-.151 3.004.484 5.492.968 7.464.272 1.062.665 2.7.453 3.064-1.421 2.458-2.994 2.761-5.263 2.427-.333-.03-.726-.091-.877-1.122-.272-1.699-1.482-10.558.181-16.839.182-.698.363-1.395.545-2.154.756-2.943 1.603-6.28 2.692-8.859 1.361-3.246 2.329-3.55 2.359-3.55 1.059-.303 2.269-.425 3.328-.425 1.633 0 3.055.304 3.479.789 1.936 2.276 2.42 7.373.847 8.95zm24.078-7.827c-6.534 3.732-12.463 5.764-16.304 5.643.302-4.066-1.029-8.495-3.388-11.226-3.418-3.974-10.285-3.428-13.643-2.548 1.089-3.55 2.057-6.645 2.723-8.617 6.443 1.153 12.704 1.821 14.943 1.881 6.262.152 11.101-.151 14.731-.637.242.061.484.122.726.122 4.538.333 10.315 2.093 10.951 3.883.786 2.185-3.025 7.069-10.739 11.499z"
                fill="#414142"
            />
            <text
                fill="#FBA919"
                style={{
                    whiteSpace: 'pre'
                }}
                fontFamily="Paytone One"
                fontSize={30}
                letterSpacing="0em"
            >
                <tspan x={66} y={72.95}>
                    {'IMA\u0160 KAK\u0160NO DOBRO '}
                </tspan>
                <tspan x={66} y={107.95}>
                    FOTOGRAFIJO?
                </tspan>
            </text>
            <g onClick={handleClick} style={{ cursor: 'pointer' }}>
                <path
                    d="M181 266c0-11.046 8.954-20 20-20h231v20c0 11.046-8.954 20-20 20H201c-11.046 0-20-8.954-20-20z"
                    fill="#414142"
                />
                <text
                    fill="#fff"
                    style={{
                        whiteSpace: 'pre'
                    }}
                    fontFamily="Roboto"
                    fontSize={14}
                    fontWeight="bold"
                    letterSpacing=".05em"
                >
                    <tspan x={228.433} y={271.285}>
                        Dodaj fotografije in sodeluj
                    </tspan>
                </text>
                <g clipPath="url(#prefix__clip0)">
                    <g
                        style={{
                            mixBlendMode: 'multiply'
                        }}
                        opacity={0.3}
                    >
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.079-5.727-10.438 3.753 10.076-28.929 17.112 4.998-13.206 28.917z"
                            fill="#fff"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.12-5.782-10.397 3.808 10.076-28.929 16.916 4.998-13.01 28.917z"
                            fill="#EFEFEF"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.162-5.839-10.355 3.865 10.076-28.929 16.72 4.998-12.814 28.917z"
                            fill="#DFDFDF"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.205-5.896-10.312 3.922 10.076-28.929 16.525 4.998-12.619 28.917z"
                            fill="#CFCFCF"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.246-5.953-10.271 3.979 10.076-28.929 16.328 4.998-12.422 28.917z"
                            fill="#BFBFBF"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.288-6.009-10.229 4.035 10.076-28.929 16.133 4.998-12.227 28.917z"
                            fill="#AFAFAF"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.33-6.066-10.187 4.092 10.076-28.929 15.936 4.998-12.03 28.917z"
                            fill="#9F9F9F"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.373-6.123-10.144 4.149 10.076-28.929 15.74 4.998-11.834 28.917z"
                            fill="#8F8F8F"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.414-6.18-10.103 4.206 10.076-28.929 15.545 4.998-11.639 28.917z"
                            fill="gray"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.456-6.236-10.061 4.262 10.076-28.929 15.348 4.998-11.442 28.917z"
                            fill="#707070"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.498-6.293-10.019 4.319 10.076-28.929 15.153 4.998-11.247 28.917z"
                            fill="#606060"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.539-6.35-9.978 4.376 10.076-28.929 14.956 4.998-11.05 28.917z"
                            fill="#505050"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.582-6.407-9.935 4.433 10.076-28.929 14.761 4.998-10.855 28.917z"
                            fill="#404040"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.624-6.464-9.893 4.49 10.076-28.929 14.565 4.998-10.659 28.917z"
                            fill="#303030"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.666-6.52-9.851 4.546 10.076-28.929 14.368 4.998-10.462 28.917z"
                            fill="#202020"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.707-6.577-9.81 4.603 10.076-28.929 14.173 4.998-10.267 28.917z"
                            fill="#101010"
                            opacity={0.3}
                        />
                        <path
                            d="M196.099 306.319l-1.465-3.012-2.75-6.634-9.767 4.66 10.076-28.929 13.976 4.998-10.07 28.917z"
                            fill="#000"
                            opacity={0.3}
                        />
                    </g>
                    <path
                        d="M196.099 306.319l-1.465-3.012-2.75-6.634-9.767 4.66 10.076-28.929 13.976 4.998-10.07 28.917z"
                        fill="url(#prefix__paint0_linear)"
                    />
                    <path
                        d="M195.994 304.569l-.747-1.532-3.016-7.275-8.946 4.268 9.318-26.751.21.075 12.499 4.47-.075.215-9.243 26.53zm-3.531-9.426l3.191 7.7.273.554 8.815-25.307-11.865-4.243-8.813 25.302 8.399-4.006z"
                        fill="url(#prefix__paint1_linear)"
                    />
                    <g
                        style={{
                            mixBlendMode: 'multiply'
                        }}
                        opacity={0.3}
                    >
                        <path
                            d="M219.865 297.994l-4.035-1.004-6.331-1.62-2.052 8.657-14.152-25.035 13.32-6.022 13.25 25.024z"
                            fill="#fff"
                            opacity={0.3}
                        />
                        <path
                            d="M219.865 297.994l-3.966-1.004-6.316-1.677-2.136 8.714-14.027-25.078 13.264-6.022 13.181 25.067z"
                            fill="#EFEFEF"
                            opacity={0.3}
                        />
                        <path
                            d="M219.865 297.994l-3.897-1.004-6.302-1.734-2.22 8.771-13.899-25.121 13.208-6.02 13.11 25.108z"
                            fill="#DFDFDF"
                            opacity={0.3}
                        />
                        <path
                            d="M219.866 297.994l-3.825-1.004-6.289-1.79-2.304 8.827-13.774-25.163 13.152-6.021 13.04 25.151z"
                            fill="#CFCFCF"
                            opacity={0.3}
                        />
                        <path
                            d="M219.865 297.994l-3.755-1.004-6.276-1.847-2.387 8.884-13.648-25.206 13.096-6.021 12.97 25.194z"
                            fill="#BFBFBF"
                            opacity={0.3}
                        />
                        <path
                            d="M219.866 297.994l-3.685-1.004-6.261-1.904-2.472 8.941-13.522-25.249 13.04-6.021 12.9 25.237z"
                            fill="#AFAFAF"
                            opacity={0.3}
                        />
                        <path
                            d="M219.866 297.994l-3.616-1.004-6.247-1.961-2.556 8.998-13.396-25.29 12.984-6.022 12.831 25.279z"
                            fill="#9F9F9F"
                            opacity={0.3}
                        />
                        <path
                            d="M219.865 297.994l-3.546-1.004-6.231-2.018-2.641 9.055-13.269-25.333 12.928-6.022 12.759 25.322z"
                            fill="#8F8F8F"
                            opacity={0.3}
                        />
                        <path
                            d="M219.865 297.994l-3.476-1.004-6.219-2.074-2.723 9.111-13.144-25.376 12.872-6.022 12.69 25.365z"
                            fill="gray"
                            opacity={0.3}
                        />
                        <path
                            d="M219.866 297.994l-3.406-1.004-6.204-2.131-2.808 9.168-13.018-25.419 12.816-6.022 12.62 25.408z"
                            fill="#707070"
                            opacity={0.3}
                        />
                        <path
                            d="M219.865 297.994l-3.336-1.004-6.19-2.188-2.892 9.225-12.892-25.46 12.76-6.022 12.55 25.449z"
                            fill="#606060"
                            opacity={0.3}
                        />
                        <path
                            d="M219.865 297.994l-3.267-1.004-6.177-2.245-2.975 9.282-12.766-25.503 12.705-6.022 12.48 25.492z"
                            fill="#505050"
                            opacity={0.3}
                        />
                        <path
                            d="M219.866 297.994l-3.196-1.004-6.162-2.301-3.06 9.338-12.639-25.546 12.647-6.022 12.41 25.535z"
                            fill="#404040"
                            opacity={0.3}
                        />
                        <path
                            d="M219.866 297.994l-3.126-1.004-6.149-2.358-3.144 9.395-12.513-25.589 12.591-6.021 12.341 25.577z"
                            fill="#303030"
                            opacity={0.3}
                        />
                        <path
                            d="M219.865 297.994l-3.056-1.004-6.134-2.415-3.228 9.452-12.388-25.631 12.535-6.021 12.271 25.619z"
                            fill="#202020"
                            opacity={0.3}
                        />
                        <path
                            d="M219.866 297.994l-2.986-1.004-6.121-2.472-3.311 9.509-12.262-25.674 12.479-6.021 12.201 25.662z"
                            fill="#101010"
                            opacity={0.3}
                        />
                        <path
                            d="M219.865 297.994l-2.916-1.004-6.106-2.529-3.396 9.566-12.136-25.717 12.425-6.021 12.129 25.705z"
                            fill="#000"
                            opacity={0.3}
                        />
                    </g>
                    <path
                        d="M219.865 297.994l-2.916-1.004-6.106-2.529-3.396 9.566-12.136-25.717 12.425-6.021 12.129 25.705z"
                        fill="url(#prefix__paint2_linear)"
                    />
                    <path
                        d="M207.369 302.43l-11.246-23.83 11.33-5.489 11.241 23.832-1.524-.525-6.684-2.77-3.117 8.782zm-10.649-23.616l10.59 22.436 2.912-8.204 7.106 2.94.506.173-10.596-22.442-10.518 5.097z"
                        fill="url(#prefix__paint3_linear)"
                    />
                    <g
                        style={{
                            mixBlendMode: 'multiply'
                        }}
                        opacity={0.3}
                    >
                        <path
                            d="M201.253 288.906c11.041-.147 19.874-9.336 19.73-20.525-.145-11.189-9.212-20.141-20.253-19.995-11.041.147-19.875 9.336-19.73 20.525.145 11.19 9.212 20.141 20.253 19.995z"
                            fill="#fff"
                            opacity={0.3}
                        />
                        <path
                            d="M201.255 288.756c11.041-.146 19.874-9.335 19.73-20.525-.145-11.189-9.212-20.141-20.253-19.994-11.041.146-19.875 9.336-19.73 20.525.144 11.189 9.212 20.141 20.253 19.994z"
                            fill="#F2F2F2"
                            opacity={0.3}
                        />
                        <path
                            d="M201.261 288.604c11.041-.146 19.874-9.336 19.73-20.525-.145-11.189-9.212-20.141-20.253-19.994-11.041.146-19.875 9.335-19.73 20.524.144 11.19 9.212 20.142 20.253 19.995z"
                            fill="#E5E5E5"
                            opacity={0.3}
                        />
                        <path
                            d="M201.248 288.461c11.041-.145 19.876-9.333 19.733-20.522-.142-11.189-9.208-20.142-20.249-19.998-11.041.145-19.876 9.332-19.734 20.522.143 11.189 9.209 20.142 20.25 19.998z"
                            fill="#D9D9D9"
                            opacity={0.3}
                        />
                        <path
                            d="M201.252 288.311c11.041-.144 19.876-9.332 19.733-20.521-.142-11.189-9.208-20.143-20.249-19.998-11.041.144-19.876 9.332-19.734 20.521.143 11.189 9.209 20.143 20.25 19.998z"
                            fill="#CCC"
                            opacity={0.3}
                        />
                        <path
                            d="M201.256 288.16c11.041-.144 19.876-9.332 19.733-20.521-.142-11.189-9.208-20.143-20.249-19.998-11.041.144-19.876 9.332-19.734 20.521.143 11.189 9.209 20.143 20.25 19.998z"
                            fill="#BFBFBF"
                            opacity={0.3}
                        />
                        <path
                            d="M201.26 288.009c11.041-.144 19.876-9.332 19.733-20.521-.142-11.189-9.209-20.143-20.25-19.998-11.041.144-19.875 9.332-19.733 20.521.143 11.189 9.209 20.143 20.25 19.998z"
                            fill="#B2B2B2"
                            opacity={0.3}
                        />
                        <path
                            d="M201.264 287.858c11.041-.144 19.876-9.332 19.733-20.521-.143-11.189-9.209-20.143-20.25-19.998-11.041.144-19.876 9.332-19.733 20.521.143 11.189 9.209 20.143 20.25 19.998z"
                            fill="#A5A5A5"
                            opacity={0.3}
                        />
                        <path
                            d="M201.249 287.716c11.041-.142 19.878-9.328 19.737-20.518-.141-11.189-9.205-20.144-20.246-20.001-11.041.142-19.878 9.329-19.737 20.518.14 11.189 9.205 20.144 20.246 20.001z"
                            fill="#989898"
                            opacity={0.3}
                        />
                        <path
                            d="M201.253 287.565c11.041-.142 19.877-9.328 19.737-20.518-.141-11.189-9.205-20.144-20.246-20.001-11.042.142-19.878 9.329-19.737 20.518.14 11.189 9.205 20.144 20.246 20.001z"
                            fill="#8C8C8C"
                            opacity={0.3}
                        />
                        <path
                            d="M201.257 287.415c11.041-.143 19.877-9.329 19.737-20.518-.141-11.19-9.206-20.145-20.247-20.002-11.041.142-19.877 9.329-19.736 20.518.14 11.189 9.205 20.144 20.246 20.002z"
                            fill="#7F7F7F"
                            opacity={0.3}
                        />
                        <path
                            d="M201.263 287.264c11.041-.143 19.877-9.329 19.737-20.518-.141-11.19-9.206-20.145-20.247-20.002-11.041.142-19.877 9.329-19.737 20.518.141 11.189 9.206 20.144 20.247 20.002z"
                            fill="#727272"
                            opacity={0.3}
                        />
                        <path
                            d="M201.248 287.12c11.041-.14 19.879-9.325 19.74-20.514-.138-11.189-9.201-20.146-20.243-20.006-11.041.141-19.879 9.326-19.74 20.515.139 11.189 9.202 20.146 20.243 20.005z"
                            fill="#656565"
                            opacity={0.3}
                        />
                        <path
                            d="M201.252 286.971c11.041-.141 19.879-9.326 19.74-20.515-.139-11.189-9.202-20.146-20.243-20.005-11.041.141-19.879 9.325-19.74 20.514.139 11.19 9.202 20.146 20.243 20.006z"
                            fill="#585858"
                            opacity={0.3}
                        />
                        <path
                            d="M201.256 286.818c11.041-.14 19.879-9.325 19.74-20.514-.139-11.189-9.202-20.146-20.243-20.005-11.041.14-19.879 9.325-19.74 20.514.139 11.189 9.202 20.146 20.243 20.005z"
                            fill="#4C4C4C"
                            opacity={0.3}
                        />
                        <path
                            d="M201.26 286.669c11.041-.141 19.879-9.325 19.74-20.515-.139-11.189-9.202-20.146-20.243-20.005-11.041.141-19.879 9.325-19.74 20.515.139 11.189 9.202 20.145 20.243 20.005z"
                            fill="#3F3F3F"
                            opacity={0.3}
                        />
                        <path
                            d="M201.266 286.518c11.041-.141 19.879-9.325 19.74-20.515-.139-11.189-9.202-20.146-20.243-20.005-11.041.141-19.879 9.325-19.74 20.515.138 11.189 9.202 20.145 20.243 20.005z"
                            fill="#323232"
                            opacity={0.3}
                        />
                    </g>
                    <path
                        d="M201.266 286.518c11.041-.141 19.879-9.325 19.74-20.515-.139-11.189-9.202-20.146-20.243-20.005-11.041.141-19.879 9.325-19.74 20.515.138 11.189 9.202 20.145 20.243 20.005z"
                        fill="url(#prefix__paint4_linear)"
                    />
                    <path
                        d="M201.005 285.332c-10.376 0-18.817-8.555-18.817-19.071 0-10.515 8.441-19.07 18.817-19.07 10.377 0 18.818 8.555 18.818 19.07 0 10.516-8.441 19.071-18.818 19.071zm0-37.687c-10.129 0-18.369 8.351-18.369 18.616 0 10.266 8.24 18.618 18.369 18.618 10.13 0 18.37-8.352 18.37-18.618 0-10.265-8.24-18.621-18.37-18.621v.005z"
                        fill="url(#prefix__paint5_linear)"
                    />
                    <path
                        d="M210.831 264.752c-.182-.942-.362-2.071-.579-3.007-.307-1.311-.383-2.918-1.094-3.148-.559-.181-1.377.158-1.936.277-.043-.457.772-.105.989-.374.137-.17-.116-.93-.162-1.191l-2.597.532c-.436.089-.981.093-1.375.277-.393.184-.228-.057-.332.259-.074.224.137.754.177.997l1.064-.217c.049.321-1.219.437-1.532.473-1.022.118-1.068-.425-1.39-1.246-.559-1.439-2.98-.374-4.075-.154-.538.108-1.298.119-1.555.712-.376.864.604 1.762-.668 2.242-.41.154-1.402.456-1.827.367-.119-.025-.274-.238-.499-.277-.36-.049-.912.178-1.267.247-.234.046-.634.046-.838.162-.248.138-.265.366-.419.472-.395.277-.835.02-1.094.619-.172.396-.153.196-.174-.243-.017-.327 1.862 10.262 2.037 10.802.309.942.916.875 1.667.741 4.591-.82 9.157-1.843 13.726-2.77.867-.174 4.957-.371 4.656-1.929-.3-1.558-.606-3.083-.903-4.623zm-21.122.529l-.041.008.041-.008c-.223.046-.373-.238-.273-.416.09.343.395.271.434-.041a.308.308 0 01-.043.386.304.304 0 01-.118.071z"
                        fill="#FF7004"
                    />
                    <path
                        d="M192.48 261.293l-2.252.433a.337.337 0 00-.265.395l.09.48a.332.332 0 00.389.269l2.252-.433a.337.337 0 00.265-.395l-.09-.48a.333.333 0 00-.389-.269zM206.216 259.049l-2.213.449-.056-.316 2.213-.449.056.316z"
                        fill="#A8A7A7"
                    />
                    <path d="M207.228 258.541l-4.341.879-.209-1.172 4.341-.881.209 1.174z" fill="#fff" />
                    <path
                        d="M203.168 259.295l-.063.013-.197-1.105.063-.013.197 1.105zM203.543 259.219l-.063.013-.197-1.106.063-.012.197 1.105zM203.889 259.149l-.063.013-.197-1.106.063-.013.197 1.106zM204.17 259.092l-.063.012-.197-1.105.063-.012.197 1.105zM204.451 259.035l-.063.012-.197-1.106.063-.013.197 1.107zM204.764 258.971l-.063.013-.197-1.106.063-.012.197 1.105zM205.078 258.908l-.061.012-.199-1.105.063-.013.197 1.106zM205.423 258.838l-.063.013-.198-1.105.063-.013.198 1.105zM205.736 258.775l-.063.012-.196-1.105.061-.013.198 1.106zM206.049 258.711l-.063.012-.197-1.105.062-.012.198 1.105zM206.361 258.649l-.063.012-.196-1.107.062-.012.197 1.107zM206.707 258.578l-.063.012-.197-1.105.063-.012.197 1.105zM206.988 258.521l-.063.013-.196-1.106.062-.013.197 1.106z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M201.134 258.966l-.103-.532a.923.923 0 00-.367-.598.901.901 0 00-.676-.161l-3.963.794a.895.895 0 00-.567.407.932.932 0 00-.117.694l.104.531a.915.915 0 01-.114.698.9.9 0 01-.569.41l-5.357 1.071a.914.914 0 00-.683 1.108l.175.896a.92.92 0 00.366.596c.195.142.438.2.675.161l18.312-3.657a.889.889 0 00.325-.148.91.91 0 00.37-.6.929.929 0 00-.011-.36l-.174-.895a.92.92 0 00-.367-.597.895.895 0 00-.676-.16l-5.54 1.108a.903.903 0 01-.919-.429.927.927 0 01-.124-.337zM209.477 268.054l-18.166 3.628a.965.965 0 00-.75 1.134l.102.523a.954.954 0 001.119.761l18.165-3.629a.964.964 0 00.75-1.134l-.102-.523a.952.952 0 00-1.118-.76z"
                        fill="#fff"
                    />
                    <path d="M208.917 260.173l-20.034 4.001 1.677 8.626 20.034-4.002-1.677-8.625z" fill="#2E2E2E" />
                    <path
                        d="M205.266 264.951a5.859 5.859 0 01-.31 3.348 5.771 5.771 0 01-2.093 2.61 5.655 5.655 0 01-6.35.029 5.775 5.775 0 01-2.117-2.59 5.862 5.862 0 01-.34-3.345 5.816 5.816 0 011.551-2.972 5.658 5.658 0 017.213-.754 5.793 5.793 0 012.446 3.674z"
                        fill="#fff"
                    />
                    <path
                        d="M204.433 265.115c.193.956.1 1.949-.264 2.852a4.926 4.926 0 01-1.784 2.223 4.831 4.831 0 01-2.702.844 4.831 4.831 0 01-2.709-.82 4.93 4.93 0 01-1.803-2.208 4.998 4.998 0 01-.288-2.85 4.95 4.95 0 011.323-2.532 4.817 4.817 0 016.144-.639 4.938 4.938 0 012.083 3.13z"
                        fill="#C8C8C8"
                    />
                    <path
                        d="M204.197 265.163a4.758 4.758 0 01-.251 2.711 4.686 4.686 0 01-1.695 2.113 4.583 4.583 0 01-5.142.023 4.676 4.676 0 01-1.714-2.097 4.75 4.75 0 01-.275-2.708 4.719 4.719 0 011.256-2.407 4.579 4.579 0 015.84-.609 4.693 4.693 0 011.981 2.974z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M203.368 265.335c.15.743.078 1.514-.205 2.216a3.822 3.822 0 01-1.386 1.727 3.742 3.742 0 01-4.202.019 3.818 3.818 0 01-1.401-1.714 3.882 3.882 0 01-.226-2.214c.143-.744.5-1.429 1.026-1.967a3.764 3.764 0 011.932-1.058 3.758 3.758 0 012.843.559c.414.277.77.635 1.048 1.053.278.417.472.886.571 1.379z"
                        fill="#4C4C4B"
                    />
                    <path
                        d="M199.172 263.417h-.017a2.82 2.82 0 00-1.757 1.227c-.404.627-.549 1.389-.404 2.123a2.86 2.86 0 001.18 1.802 2.79 2.79 0 002.087.447h.018a2.815 2.815 0 001.756-1.228c.404-.626.55-1.389.404-2.123a2.86 2.86 0 00-1.179-1.801 2.791 2.791 0 00-2.088-.447z"
                        fill="#3A3A3A"
                    />
                    <path
                        d="M201.6 265.654c.076.375.04.766-.103 1.121a1.933 1.933 0 01-.7.874 1.896 1.896 0 01-2.835-.856 1.952 1.952 0 01-.114-1.12c.072-.377.253-.723.519-.996.267-.272.607-.458.978-.534a1.89 1.89 0 011.436.282c.423.284.717.725.819 1.229z"
                        fill="#3D3D3D"
                    />
                    <path
                        d="M200.911 265.796c.048.237.025.484-.065.708a1.207 1.207 0 01-1.112.762 1.2 1.2 0 01-.672-.203 1.223 1.223 0 01-.52-1.254c.045-.238.159-.457.327-.629a1.2 1.2 0 011.524-.16c.267.179.454.458.518.776z"
                        fill="#0F0F0E"
                    />
                    <path
                        opacity={0.2}
                        d="M198.816 265.165a1.214 1.214 0 01-.499 1.238 1.178 1.178 0 01-1.76-.533 1.214 1.214 0 01.253-1.313 1.175 1.175 0 011.07-.334 1.185 1.185 0 01.757.508c.088.132.148.279.179.434z"
                        fill="#fff"
                    />
                    <path
                        d="M200.096 265.964a.388.388 0 01-.158.393.374.374 0 01-.419.002.382.382 0 01-.163-.391.377.377 0 01.295-.302.381.381 0 01.445.298zM200.105 258.217l-4.095.818.267 1.372 4.094-.818-.266-1.372z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M199.432 258.482l-2.701.54a.33.33 0 00-.258.389l.092.471c.035.18.207.296.384.261l2.701-.54a.331.331 0 00.258-.388l-.092-.472a.328.328 0 00-.384-.261z"
                        fill="#3D3D3D"
                    />
                    <path d="M207.31 268.29l-.206.304-.874-.496.379-.558.701.75z" fill="#A8A7A7" />
                    <path
                        d="M207.454 268.429a.25.25 0 01-.194.287.243.243 0 01-.177-.049.246.246 0 01-.089-.162.251.251 0 01.195-.287.225.225 0 01.093.007.234.234 0 01.172.204zM206.875 267.746a.501.501 0 01-.079.367.491.491 0 01-.31.206.461.461 0 01-.352-.094.49.49 0 01-.18-.321.506.506 0 01.08-.367.491.491 0 01.31-.206.461.461 0 01.473.237.467.467 0 01.058.178zM214.398 262.366l-1.6.658-.227.094a.22.22 0 00-.147.259.21.21 0 00.257.149l1.605-.652.227-.094a.218.218 0 00.148-.259.214.214 0 00-.098-.128.207.207 0 00-.158-.022l-.007-.005zM215.25 266.198l-1.437.088-.209.013a.197.197 0 00-.08.016.214.214 0 00-.114.115.22.22 0 00.046.231.215.215 0 00.068.046c.025.01.052.016.08.016l1.437-.089.209-.012a.218.218 0 00.208-.214.215.215 0 00-.063-.149.208.208 0 00-.147-.061h.002zM214.546 270.156l-1.489-.601-.21-.085a.209.209 0 00-.254.153.221.221 0 00.025.159.213.213 0 00.126.098l1.488.603.209.084a.208.208 0 00.254-.152.218.218 0 00-.15-.259h.001zM212.511 273.516l-1.006-1.007-.145-.147a.207.207 0 00-.296.002.215.215 0 00.002.3l1.005 1.007.145.147c.04.034.092.052.144.049a.211.211 0 00.201-.205.215.215 0 00-.05-.146zM209.21 275.88l-.508-1.56-.074-.228a.226.226 0 00-.036-.075.207.207 0 00-.141-.083.207.207 0 00-.156.042.203.203 0 00-.055.062.23.23 0 00-.027.08.21.21 0 00.005.083l.508 1.558.073.225a.218.218 0 00.099.126.213.213 0 00.158.023.21.21 0 00.126-.099.217.217 0 00.021-.16l.007.006zM205.491 276.626c0-.461-.002-.923-.006-1.385v-.198a.212.212 0 00-.209-.212.212.212 0 00-.21.212l.009 1.385v.198c0 .056.022.11.061.15a.209.209 0 00.357-.15h-.002zM201.728 275.866c.158-.488.316-.976.472-1.464l.069-.209a.218.218 0 00-.024-.162.209.209 0 00-.289-.075.213.213 0 00-.097.132l-.473 1.464-.067.209a.214.214 0 00.153.26.205.205 0 00.16-.024.215.215 0 00.097-.131h-.001z"
                        fill="#fff"
                    />
                    <path
                        d="M200.907 283.68a17.146 17.146 0 01-12.206-5.124 17.613 17.613 0 01-5.056-12.371c0-4.639 1.818-9.089 5.056-12.37a17.146 17.146 0 0112.206-5.124c9.519 0 17.264 7.848 17.264 17.494s-7.745 17.495-17.264 17.495zm0-34.737a16.853 16.853 0 00-9.453 2.906 17.2 17.2 0 00-6.267 7.739 17.454 17.454 0 00-.968 9.963 17.315 17.315 0 004.657 8.829 16.943 16.943 0 008.713 4.719c3.3.665 6.722.324 9.831-.982a17.066 17.066 0 007.636-6.351 17.416 17.416 0 002.867-9.581 17.382 17.382 0 00-4.99-12.187 16.923 16.923 0 00-12.026-5.055z"
                        fill="#fff"
                    />
                </g>
            </g>
            <defs>
                <linearGradient
                    id="prefix__paint0_linear"
                    x1={201.033}
                    y1={303.934}
                    x2={186.978}
                    y2={274.937}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A8141D" />
                    <stop offset={0.1} stopColor="#B7181D" />
                    <stop offset={0.33} stopColor="#D31F1D" />
                    <stop offset={0.55} stopColor="#E8251D" />
                    <stop offset={0.78} stopColor="#F4281D" />
                    <stop offset={1} stopColor="#F8291D" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint1_linear"
                    x1={200.64}
                    y1={302.324}
                    x2={187.71}
                    y2={275.65}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F8291D" />
                    <stop offset={0.22} stopColor="#F4281D" />
                    <stop offset={0.45} stopColor="#E8251D" />
                    <stop offset={0.67} stopColor="#D31F1D" />
                    <stop offset={0.9} stopColor="#B7181D" />
                    <stop offset={1} stopColor="#A8141D" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint2_linear"
                    x1={-115297}
                    y1={-152120}
                    x2={-120633}
                    y2={-154726}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A8141D" />
                    <stop offset={0.1} stopColor="#B7181D" />
                    <stop offset={0.33} stopColor="#D31F1D" />
                    <stop offset={0.55} stopColor="#E8251D" />
                    <stop offset={0.78} stopColor="#F4281D" />
                    <stop offset={1} stopColor="#F8291D" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint3_linear"
                    x1={-106276}
                    y1={-139813}
                    x2={-110801}
                    y2={-142038}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F8291D" />
                    <stop offset={0.22} stopColor="#F4281D" />
                    <stop offset={0.45} stopColor="#E8251D" />
                    <stop offset={0.67} stopColor="#D31F1D" />
                    <stop offset={0.9} stopColor="#B7181D" />
                    <stop offset={1} stopColor="#A8141D" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint4_linear"
                    x1={186.868}
                    y1={251.935}
                    x2={215.521}
                    y2={280.207}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF9E00" />
                    <stop offset={0.29} stopColor="#FF9A00" />
                    <stop offset={0.59} stopColor="#FF8E01" />
                    <stop offset={0.89} stopColor="#FF7903" />
                    <stop offset={1} stopColor="#FF7004" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint5_linear"
                    x1={187.706}
                    y1={252.783}
                    x2={214.66}
                    y2={279.382}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF7004" />
                    <stop offset={0.11} stopColor="#FF7903" />
                    <stop offset={0.41} stopColor="#FF8E01" />
                    <stop offset={0.71} stopColor="#FF9A00" />
                    <stop offset={1} stopColor="#FF9E00" />
                </linearGradient>
                <clipPath id="prefix__clip0">
                    <path fill="#fff" transform="translate(181 246)" d="M0 0h40v60.319H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default PhotoUploadBaloonPrizeContest;
